import * as d3 from 'd3'
import emptyThumb from '../../assets/images/emptydata.svg'
import './styles.css'
import Chart from '../../ultils/Chart'
import d3tip from '../../ultils/d3-tip'
import moment from 'moment'

class FocusChart extends Chart {
  init({ data, events, triggerZoom, registerFocusChartTimeChange, currency }) {
    let vis = this
    vis.data = data
    vis.events = events
    vis.currency = currency
    vis.marketContextToggleObj = {
      showRiskEvents: false,
      showUnrecognisedRiskStatus: true,
    }
    vis.triggerZoom = triggerZoom

    vis.tip = d3tip()
      .attr('class', 'd3-tip-focus-chart')
      .html((e, d) => {
        return `
        <div class="tip-content">
          <div class="tip-header">
            <p class="tip-date">${moment(d.date).format('MMM DD, YYYY')}</p>
            <p class="tip-price">${d.title}</p>
          </div>
        </div>
      `
      })
    vis.g.call(vis.tip)

    vis.tooltipLine1 = vis.g.append('line')
    vis.tooltipLine2 = vis.g.append('line')

    vis.clipRect = vis.svg
      .append('defs')
      .append('clipPath')
      .attr('id', 'clip')
      .append('rect')
      .attr('x', 0)

    vis.lg = vis.svg
      .append('defs')
      .append('linearGradient')
      .attr('id', 'mygrad')
      .attr('x1', '0%')
      .attr('x2', '0%')
      .attr('y1', '0%')
      .attr('y2', '100%')
    vis.lg
      .append('stop')
      .attr('offset', '0%')
      .style('stop-color', 'rgba(51, 147, 243)')
      .style('stop-opacity', 0.4)

    vis.lg
      .append('stop')
      .attr('offset', '100%')
      .style('stop-color', 'rgba(51, 147, 243)')
      .style('stop-opacity', 0)

    vis.g
      .append('path')
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', '#3393F3')
      .attr('stroke-width', '3px')

    vis.g.append('path').attr('class', 'area')

    vis.x = d3.scaleTime()
    vis.y = d3.scaleLinear()

    vis.xAxisCall = d3.axisBottom().ticks(7).tickFormat(d3.timeFormat('%b %Y'))
    vis.yAxisCall = d3.axisLeft().ticks(6)

    vis.xAxis = vis.g
      .append('g')
      .attr('class', 'xAxisFocusChart')
      .attr('clip-path', 'url(#clip)')
      .attr('transform', `translate(0, ${vis.HEIGHT})`)
    vis.yAxis = vis.g.append('g').attr('class', 'yAxisFocusChart')

    vis.zoom = d3.zoom().scaleExtent([1, Infinity]).on('zoom', vis.triggerZoom)

    vis.zoomRect = vis.g.append('rect').attr('class', 'zoom')

    vis.line = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d.Price) || !isNaN(d.date))
      .x(d => vis.x(d.date))
      .y(d => vis.y(d.Price))

    vis.area = d3
      .area()
      .curve(d3.curveCatmullRom)
      .x(d => vis.x(d.date))
      .y0(vis.HEIGHT)
      .y1(d => vis.y(d.Price))

    registerFocusChartTimeChange(vis)

    vis.minText = vis.g
      .append('text')
      .attr('x', 10)
      .attr('y', vis.HEIGHT - 20)
      .attr('class', 'minMaxText')

    vis.maxText = vis.g
      .append('text')
      .attr('x', 10)
      .attr('y', 0)
      .attr('class', 'minMaxText')

    vis.update({ data, events })
  }

  updateStyleForXAsix() {
    const vis = this
    vis.xAxis
      .select('.domain')
      .attr('stroke', '#DFE4EB')
      .attr('stroke-width', '1')

    vis.xAxis
      .selectAll('.tick line')
      .attr('x1', 0)
      .attr('y1', 0)
      .attr('x2', 0)
      .attr('y2', 6)
      .attr('stroke', '#DFE4EB')

    vis.xAxis.selectAll('.tick text').attr('class', 'tickTextFocusChart')
  }

  update({ data, events, onZoom }) {
    let vis = this
    vis.data = data || vis.data
    vis.events = events || vis.events
    vis.svg.selectAll('image').remove()

    if (vis.data.length > 1) {
      if (!onZoom) {
        vis.svg.selectAll('image').remove()
        if(d3.min(d3.map(vis.data, d => d.Price))) {
          vis.minText.text(`Min: ${vis?.currency} ${d3.min(d3.map(vis.data, d => d.Price))}`)
        } else {
          vis.minText.text(null)
        }
        if(d3.max(d3.map(vis.data, d => d.Price))) {
          vis.maxText.text(`Max: ${vis?.currency} ${d3.max(d3.map(vis.data, d => d.Price))}`)
        } else {
          vis.maxText.text(null)
        }
      }
    } else {
      vis.data = []
      vis.events = []
      vis.svg
        .append('svg:image')
        .attr('xlink:href', emptyThumb)
        .attr('x', vis.WIDTH / 2 - 77 + vis.MARGIN.LEFT)
        .attr('y', vis.HEIGHT / 2 - 37 + vis.MARGIN.TOP)
        .attr('width', '155')
        .attr('height', '73')
      vis.minText.text('')
      vis.maxText.text('')
      vis.g.selectAll('.tick').remove()
    }
    vis.updateStyleForXAsix()

    vis.clipRect.attr('width', vis.WIDTH).attr('height', vis.HEIGHT)

    vis.zoom
      .translateExtent([
        [0, 0],
        [vis.WIDTH, vis.HEIGHT],
      ])
      .extent([
        [0, 0],
        [vis.WIDTH, vis.HEIGHT],
      ])

    vis.zoomRect
      .attr('width', vis.WIDTH)
      .attr('height', vis.HEIGHT)
      .call(vis.zoom)

    if (!onZoom) {
      vis.x.range([0, vis.WIDTH]).domain(d3.extent(vis.data, d => d.date))
      vis.y
        .range([vis.HEIGHT - 50, 0])
        .domain([
          d3.min(vis.data, d => Number(d.Price)) / 1.05,
          d3.max(vis.data, d => Number(d.Price)) * 1.05,
        ])
    }

    vis.xAxisCall.scale(vis.x)
    vis.xAxis.call(vis.xAxisCall)
    vis.yAxisCall.scale(vis.y)
    vis.yAxis.call(vis.yAxisCall)

    vis.g
      .select('.line')
      .attr('stroke', '#3393F3')
      .attr('d', vis.line(vis.data))

    vis.g
      .select('.area')
      .attr('class', 'area')
      .attr('d', vis.area(vis.data))
      .style('fill', 'url(#mygrad)')

    if (!onZoom) {
      vis.x.domain(d3.extent(vis.data, d => d.date))
      vis.y.domain([
        d3.min(vis.data, d => Number(d.Price)) / 1.05,
        d3.max(vis.data, d => Number(d.Price)) * 1.05,
      ])
    }

    vis.addEventCircles()
  }

  filterByMarketContextToggle(d) {
    const vis = this
    if (!vis.marketContextToggleObj) {
      return true
    }
    return vis.isRiskEvent(d)
      ? vis.marketContextToggleObj.showRiskEvents
      : vis.marketContextToggleObj.showUnrecognisedRiskStatus
  }

  getEventColor(d) {
    if (!d['signal_data_array'] || d['signal_data_array'].length === 0) {
      return '#1D3967'
    }
    const riskLevel = d['signal_data_array'][0]['risk_level']
    const colorEventScale = d3
      .scaleLinear()
      .domain([0, -1, -2, -3])
      .range(['#758396', '#FF5C5C', '#D10000', '#800202'])
    return colorEventScale(riskLevel)
  }

  isRiskEvent(d) {
    return !d['signal_data_array'] || d['signal_data_array'].length === 0
  }

  countCyValue(d) {
    const vis = this
    const bisect = d3.bisector(d => d.date).left
    const i = bisect(vis.data, d.date)
    const val = vis.data[i]

    if (!val) return null

    function findOffsetRecursive(index, offset) {
      if (index <= 0) return offset
      const da = vis.events[index - 1]
      if (
        (da && da.Date !== d.Date) ||
        (da && vis.isRiskEvent(da) !== vis.isRiskEvent(d))
      )
        return offset
      return findOffsetRecursive(index - 1, offset + 10)
    }

    const offset = findOffsetRecursive(d.id, 0)

    return vis.y(val.Price) + offset
  }

  removeTooltip() {
    const vis = this
    if (vis.tooltipLine1) vis.tooltipLine1.attr('stroke', 'none')
    if (vis.tooltipLine2) vis.tooltipLine2.attr('stroke', 'none')
  }

  drawTooltip(e, d) {
    const vis = this
    const yValue = vis.countCyValue(d)

    vis.tooltipLine1
      .attr('x1', vis.x(d.date))
      .attr('y1', 0)
      .attr('x2', vis.x(d.date))
      .attr('y2', vis.HEIGHT)
      .attr('stroke', '#1B3963')
      .attr('stroke-dasharray', '2, 2')
      .attr('stroke-width', '1px')
      .attr('opacity', 0.3)

    vis.tooltipLine2
      .attr('x1', 0)
      .attr('y1', yValue)
      .attr('x2', vis.WIDTH)
      .attr('y2', yValue)
      .attr('stroke', '#1B3963')
      .attr('stroke-dasharray', '2, 2')
      .attr('stroke-width', '1px')
      .attr('opacity', 0.3)

    vis.tip.html((e, d) => {
      return `
          <div class="tip-content">
            <div class="tip-header">
              <p class="tip-date">${moment(d.date).format('MMM, YYYY')}</p>
              <p class="tip-price">${d.title}</p>
            </div>
          </div>
        `
    })
    vis.tip.show(e, d)
  }

  addEventCircles() {
    const vis = this
    vis.g.selectAll('.event').remove()
    const listEventData = vis.events.filter(d =>
      vis.marketContextToggleObj.showRiskEvents
        ? vis.isRiskEvent(d)
        : !vis.isRiskEvent(d),
    )
    vis.events.length > 0 &&
      vis.g
        .selectAll('.event')
        .data(listEventData, d => d.id)
        .join(
          enter =>
            enter
              .append('circle')
              .attr('class', 'event')
              .attr('cx', d => vis.x(d.date))
              .attr('cy', d => vis.countCyValue(d))
              .attr('r', '5')
              .attr('fill', d => vis.getEventColor(d))
              .style('stroke', 'white')
              .style('stroke-width', '1px')
              .style('opacity', d =>
                vis.filterByMarketContextToggle(d) ? 1 : 0,
              )
              .on('mousemove', (e, d) => {
                vis.filterByMarketContextToggle(d) && vis.drawTooltip(e, d)
              })
              .on('mouseout', () => {
                vis.tip.hide()
                vis.removeTooltip()
              }),
          update => {
            update.attr('cx', d => vis.x(d.date))
            update.attr('cy', d => vis.countCyValue(d))
          },
          exit => exit.remove(),
        )
  }

  zoomed = ({ transform }) => {
    const vis = this
    vis.x.range([0, vis.WIDTH].map(d => transform?.applyX(d)))
    vis.xAxisCall.scale(vis.x)

    // current bounds of visualization
    const minDate = vis.x.invert(0)
    const maxDate = vis.x.invert(vis.WIDTH)

    const filteredData = vis.data.filter(
      d => d.date > minDate && d.date < maxDate,
    )
    vis.y.domain([
      d3.min(filteredData, d => Number(d.Price)) / 1.05,
      d3.max(filteredData, d => Number(d.Price)) * 1.05,
    ])
    vis.yAxisCall.scale(vis.y)

    if(d3.min(d3.map(filteredData, d => d.Price))) {
      vis.minText.text(`Min: ${vis?.currency} ${d3.min(d3.map(filteredData, d => d.Price))}`)
    } else {
      vis.minText.text(null)
    }

    if(d3.max(d3.map(filteredData, d => d.Price))) {
      vis.maxText.text(`Max: ${vis?.currency} ${d3.max(d3.map(filteredData, d => d.Price))}`)
    } else {
      vis.maxText.text(null)
    }

    vis.update({
      data: vis.data,
      events: vis.events,
      onZoom: true,
    })
  }

  brushed = ({ sourceEvent, selection, target }) => {
    if (!sourceEvent || sourceEvent.type === 'zoom') return // ignore brush-by-zoom
    const vis = this
    const s = selection || [0, vis.WIDTH]
    vis.svg
      .select('.zoom')
      .call(
        vis.zoom.transform,
        d3.zoomIdentity.scale(vis.WIDTH / (s[1] - s[0])).translate(-s[0], 0),
      )
  }

  toggleUpdate = ({ toggleProp }) => {
    const vis = this
    vis.marketContextToggleObj = toggleProp || {
      showRiskEvents: false,
      showUnrecognisedRiskStatus: true,
    }
    vis.addEventCircles()
  }
}

export default FocusChart
